import { MessageQuestionSquareIcon } from '@/components/icons/MessageQuestionSquareIcon';
import { diagnostics } from '@/utils/diagnostics';

import { MenuItem } from './MenuItem';
import { SidebarVariant } from './Sidebar';
import { menuItemSxProps } from './sidebarConstants';

interface HelpMenuItemProps {
  isExpanded: boolean;
  colorTheme: SidebarVariant;
}

export function HelpMenuItem({ isExpanded, colorTheme }: HelpMenuItemProps) {
  return (
    <MenuItem
      text="Help"
      icon={<MessageQuestionSquareIcon size={16} />}
      tooltipTitle="Help"
      variant={isExpanded ? 'large' : 'small'}
      menuItemSxProps={menuItemSxProps}
      colorTheme={colorTheme}
      typographyProps={{ variant: 'body-xs' }}
      showTooltip={!isExpanded}
      isActive={false}
      onClick={() => {
        if (typeof window.Pylon === 'function') {
          window.Pylon('show');
        } else {
          diagnostics.error('Pylon is not available');
        }
      }}
    />
  );
}
